const textFields = ['waybillNo', 'vehicleNo', 'driverName', 'startAddress', 'endAddress', 'cargoName']
const timeFields = ['createTime', 'planDepartTime', 'planArriveTime', 'startFenceTime', 'endFenceTime']
const sortFields = ['createTime', 'planDepartTime', 'planArriveTime', 'actualDepartTime', 'actualArriveTime']

function createListQuery(now = Date.now()) {
  const start = new Date(now)
  start.setHours(0, 0, 0, 0)
  start.setDate(start.getDate() - 6)
  const end = new Date(now)
  end.setHours(23, 59, 59, 999)
  return { waybillNo: '', vehicleNo: '', driverName: '', startAddress: '', endAddress: '', cargoName: '', status: '', alarmType: '', timeField: 'createTime', timeRange: [start.getTime(), end.getTime()], hideCanceled: false }
}

function buildListParams(query, paging = {}) {
  const params = { ...paging, timeField: query.timeField, hideCanceled: query.hideCanceled }
  if (paging.sortOrder) params.sortOrder = paging.sortOrder === 'ascending' ? 'asc' : 'desc'
  textFields.forEach(field => { if (query[field]) params[field] = query[field].trim() })
  if (query.status !== '' && query.status !== null && query.status !== undefined) params.status = query.status
  if (query.alarmType !== '' && query.alarmType !== null && query.alarmType !== undefined) params.alarmType = query.alarmType
  if (Array.isArray(query.timeRange) && query.timeRange.length === 2) {
    params.startTime = Number(query.timeRange[0])
    params.endTime = Number(query.timeRange[1])
  }
  return params
}

function filterEmbedWaybills(rows, query, sortField = 'createTime', sortOrder = 'descending') {
  const result = rows.filter(row => {
    if (query.hideCanceled && Number(row.transportStatus) === 3) return false
    if (query.status !== '' && Number(row.transportStatus) !== Number(query.status)) return false
    if (textFields.some(field => query[field] && !String(row[field] || '').toLowerCase().includes(query[field].toLowerCase()))) return false
    if (query.timeRange && query.timeRange.length === 2) {
      const value = new Date(row[query.timeField]).getTime()
      if (!Number.isFinite(value) || value < query.timeRange[0] || value > query.timeRange[1]) return false
    }
    return true
  })
  const direction = sortOrder === 'ascending' ? 1 : -1
  return result.sort((left, right) => {
    const a = new Date(left[sortField]).getTime() || 0
    const b = new Date(right[sortField]).getTime() || 0
    return (a - b || Number(left.id || 0) - Number(right.id || 0)) * direction
  })
}

function parseListState(value) {
  if (!value || typeof value !== 'string') return null
  let state
  try { state = JSON.parse(value) } catch (error) { return null }
  if (!state || !state.query || !Number.isInteger(state.page) || state.page < 1 || ![10, 15, 20, 50, 100].includes(state.pageSize)) return null
  const query = createListQuery()
  textFields.forEach(field => { query[field] = typeof state.query[field] === 'string' ? state.query[field] : '' })
  query.status = [0, 1, 2, 3, 4].includes(state.query.status) ? state.query.status : ''
  query.alarmType = [1, 2, 3, 4, 5].includes(state.query.alarmType) ? state.query.alarmType : ''
  query.timeField = timeFields.includes(state.query.timeField) ? state.query.timeField : 'createTime'
  query.hideCanceled = state.query.hideCanceled === true
  const range = state.query.timeRange
  query.timeRange = Array.isArray(range) && range.length === 2 && range.every(Number.isFinite) && range[0] <= range[1] ? range.slice() : []
  return { query, page: state.page, pageSize: state.pageSize, sortField: sortFields.includes(state.sortField) ? state.sortField : 'createTime', sortOrder: state.sortOrder === 'ascending' ? 'ascending' : 'descending' }
}

module.exports = { createListQuery, buildListParams, filterEmbedWaybills, parseListState }
